<template>
  <div class="page-container">
    <header class="white">
      <page-header
        :title="title"
        :show-appointment-info="showAppointmentInfo"
        :hide-back-button="hideBackButton"
        :large="largeHeader"
        @back-cta-click="ctaBackClicked"
      >
        <template #additionContent>
          <slot name="headerContent" />
        </template>
      </page-header>
    </header>
    <pp-container
      tag="main"
      class="py-0 d-flex flex-column page-container__main justify-start"
      :class="{'narrow':narrow}"
    >
      <slot name="content" />
    </pp-container>

    <slot name="footer">
      <footer
        v-if="!hideFooter"
        class="white mt-auto"
      >
        <pp-divider />
        <pp-container>
          <div
            class="d-flex"
            :class="containerButtonClass"
          >
            <pp-button
              v-if="showFooterBackButton"
              type="secondary"
              class="ml-sm-10"
              data-cy-id="page-back-button"
              :loading="loadingFooterButton"
              @click="ctaBackClicked"
            >
              <template #text>
                <span class="px-sm-10">Back</span>
              </template>
            </pp-button>
            <pp-button
              append-icon="arrow--right"
              type="primary"
              class="mr-sm-10 page-continue-button"
              data-cy-id="page-continue-button"
              :disabled="disableFooterButton"
              :loading="loadingFooterButton"
              @click="ctaClicked"
            >
              <template #text>
                <span class="px-sm-10">Continue</span>
              </template>
            </pp-button>
          </div>
        </pp-container>
      </footer>
    </slot>
  </div>
</template>

<script>
import PageHeader from '@/components/page-header/PageHeader'

export default {
  name: 'PageContainer',
  components: {
    'page-header': PageHeader
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    loadingFooterButton: {
      type: Boolean,
      default: false
    },
    disableFooterButton: {
      type: Boolean,
      default: false
    },
    hideBackButton: {
      type: Boolean,
      default: false
    },
    narrow: {
      type: Boolean,
      default: true
    },
    showAppointmentInfo: {
      type: Boolean,
      default: true
    },
    largeHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showFooterBackButton () {
      return !this.$ppUi.isMobile && !this.hideBackButton
    },
    containerButtonClass () {
      return this.showFooterBackButton ? 'justify-space-between' : 'justify-end'
    }
  },
  methods: {
    ctaClicked () {
      this.$emit('primary-cta-click')
    },
    ctaBackClicked () {
      this.$emit('back-cta-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  display: flex;
  flex: 1 0 100vh;
  flex-direction: column;
  max-width: 100vw;
  overflow: auto;

  @include mobile() {
    // iframe container will be set to 100vh
    height: 100%;
  }

  &__main {
    flex: 1 0 200px;
    overflow: auto;
    transform: translate(0, 0);
  }
}

header {
  position: sticky;
  top: 0;
  z-index: 7;
}

.page-continue-button {
  @include mobile() {
    width: 100%;
  }
}

.narrow {
  @include desktop() {
    max-width: 80%;
  }
}

footer {
  bottom: 0;
  position: sticky;
  width: 100%;
  z-index: 7;
}

</style>
